export enum Roles {
    Admin = 1,
    Regular = 2,
}
export type Role = Roles.Admin | Roles.Regular
